module.exports = __webpack_public_path__ + "media/newstyle/images/emoji_language-f929a364ed5cc8611ddc9acd4d5ac98d.svg";